import SignInCallbackContainer from './SignInCallback.container';

export default SignInCallbackContainer;
